import { render, staticRenderFns } from "./router_view.vue?vue&type=template&id=b5a5e6b6"
import script from "./router_view.vue?vue&type=script&lang=js"
export * from "./router_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports